import { terminalConstants } from "./terminal.constants";
export const merchantTerminalActions = {
	setCreateStageOnlyVarInProgress,
};

function setCreateStageOnlyVarInProgress(inProgress) {
	return {
		type: terminalConstants.SET_CREATE_STAGE_ONLY_VAR_IN_PROGRESS,
		inProgress,
	};
}
